import { render, staticRenderFns } from "./APISpecification.vue?vue&type=template&id=1390a2d4"
import script from "./APISpecification.vue?vue&type=script&lang=js"
export * from "./APISpecification.vue?vue&type=script&lang=js"
import style0 from "./APISpecification.vue?vue&type=style&index=0&id=1390a2d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports